import { combineReducers } from 'redux'

import linear from './list/linear'
import tree from './list/tree'

export default combineReducers({
  linear,
  tree
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/locations/list.js